import type { SignoffStatus } from "./board";

/**
 * The stoplight palette — the brand's red/amber/green, used for column accents,
 * count badges, sign-off dots, and the decision blocks. One source of truth so
 * the hex values aren't scattered across components.
 */
export const STOPLIGHT = {
  amber: "#E8A23D",
  red: "#E5544B",
  green: "#10CE63",
} as const;

/** Darker amber for text/flags that need contrast on light backgrounds. */
export const AMBER_TEXT = "#B07F00";

/** ClickUp's mention/link purple, used in comment rendering. */
export const CLICKUP_PURPLE = "#7B68EE";

/** Each sign-off column's accent (matches its stoplight icon). */
export const SIGNOFF_COLOR: Record<SignoffStatus | "archived", string> = {
  pending_review: STOPLIGHT.amber,
  changes_requested: STOPLIGHT.red,
  accepted: STOPLIGHT.green,
  archived: "#8B8B8B",
};
